// extracted by css-extract-rspack-plugin
export default {"cls1":"ResearcherList-cls1_PNa","cls2":"ResearcherList-cls2_kF2 ResearcherList-cls1_PNa"};